import React from 'react';
import { Box, Container } from '@chakra-ui/react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Image, Heading, Text } from '@chakra-ui/react';
import { Stack } from '@chakra-ui/react';
import Hii from './Hii';

import img1 from '../assets/1.jpg';
import img2 from '../assets/2.jpg';
import img3 from '../assets/3.jpg';
import img4 from '../assets/4.jpg';
import img5 from '../assets/5.png';

const obj = {
  size: '4xl',
  p: '5',
  bgColor: 'blackAlpha.600',
  color: 'white',
  pos: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50%)',
  //    borderRadius:"3rem",
};

const Home = () => {
  return (
    <>
    <Box w={'full'} h={'100vh'}>
      <MyCarousel />
    </Box>
    <Box>
      <Hii />
    </Box>
    </>
  );
};

const MyCarousel = () => (
  <Carousel
    autoPlay
    infiniteLoop
    showArrows={false}
    showThumbs={false}
    showStatus={false}
    interval={1000}
  >
    <Box w={'full'} h="100vh">
      <Heading {...obj}>See The Future</Heading>
      <Image src={img1}  h={"full"} w={"full"} objectFit={"cover"} />
    </Box>
    <Box w={'full'} h="100vh">
      <Heading {...obj}>Future is Gaming</Heading>
      <Image src={img2}   h={"full"} w={"full"} objectFit={"cover"}/>
    </Box>
    <Box w={'full'} h="100vh" >
      <Heading {...obj}>Gaming on Console</Heading>
      <Image src={img3} h={"full"} w={"full"} objectFit={"cover"} />
    </Box>
    <Box w={'full'} h="100vh" >
      <Heading {...obj}>Night Life</Heading>
      <Image src={img4}  h={"full"} w={"full"} objectFit={"cover"}/>
    </Box>
  </Carousel>
);

export default Home;
